export const ADMIN_NAV_ICONS: Record<string, string> = {
  '/admin': 'dashboard',
  '/admin/orders': 'shopping_cart',
  '/admin/products': 'inventory_2',
  '/admin/bundles': 'category',
  '/admin/brands': 'branding_watermark',
  '/admin/categories': 'auto_awesome_mosaic',
  '/admin/category-filters': 'filter_alt',
  '/admin/category-specs': 'label',
  '/admin/users': 'group',
  '/admin/settings': 'settings',
  '/admin/ai-marketing': 'smart_toy',
  '/admin/chat': 'forum'
};

export function adminNavIcon(path: string): string {
  if (ADMIN_NAV_ICONS[path]) {
    return ADMIN_NAV_ICONS[path];
  }

  if (path.startsWith('/admin/ai-marketing')) {
    return ADMIN_NAV_ICONS['/admin/ai-marketing'];
  }

  return 'chevron_right';
}
